import Actions from './export-task-actions';
import Api from './export-task-api';
import Collection from './export-task-collection';
import Model from './export-task-model';
import reducer from './export-task-reducer';
import sagas from './export-task-sagas';
import Selectors from './export-task-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'exportTask',
  reducer,
  sagas:     [sagas],
  Selectors,
};
